// src/components/Home/Home.jsx
import React, { useEffect, useState } from 'react';
import SliderHome from '../SliderHome/SliderHome';
import Características from '../Caracteristicas/Caracteristicas';
import Clientes from '../Clientes/Clientes';
import Productos from '../Productos/Productos';
import Testimonial from '../Testimonial/Testimonial';
import Loader from '../../elements/Loader/Loader';
import { useToast } from '../../../Contexts/Toast/toast.provider';
import useStore from '../../../useStore';
import './home.css';

const Home = () => {
  // — Store —
  const { homes, fetchHomes, loading, error } = useStore();
  const showToast = useToast();

  // — Estados locales —
  const [banner, setBanner] = useState(null);
  const [productos, setProductos] = useState([]);
  const [popupDesktop, setPopupDesktop] = useState(null);
  const [popupMobile, setPopupMobile] = useState(null);
  const [popUpLink, setPopUpLink] = useState(null);
  const [popupActive, setPopupActive] = useState(false);
  const [testimonials, setTestimonials] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  // 1) Al montar: disparar fetch + detectar mobile
  useEffect(() => {
    fetchHomes();
    setIsMobile(window.innerWidth <= 920);
  }, [fetchHomes]);

  // 2) Mostrar toast si ocurre error
  useEffect(() => {
    if (error) {
      showToast('error', 'Error al cargar datos de Home');
    }
  }, [error, showToast]);

  // 3) Cuando llegan los datos, derivar estados locales
  useEffect(() => {
    if (!homes || homes.length === 0) return;

    // Banner
    const bannerItems = homes.flatMap(item => item.bannePrincipalHome || []);
    setBanner(bannerItems[0] || null);

    // Testimonios
    setTestimonials(homes[0]?.SeccionTestimonios || []);

    // Popup
    const { popup } = homes[0] || {};
    setPopupActive(Boolean(popup?.popupActive));
    setPopupDesktop(popup?.escritorio?.url || null);
    setPopupMobile(popup?.mobile?.url || null);
    setPopUpLink(popup?.link || null);

    // Productos
    const productosComponent = homes.flatMap(item =>
      item.productosComponent?.map(category => ({
        category: category.categoria,
        slug: category.slug,
        description: category.descripcion,
        products:
          category.itemProductoCompoent?.map(prod => ({
            slug: prod.slug,
            images: [
              {
                urlDesktop: prod.imagenEscritorio?.url,
                urlMobile: prod.imagenMobile?.url,
                urlCategory: prod.imagenCategoria?.url,
                title: prod.nombre,
                description: category.descripcion
              }
            ]
          })) || []
      })) || []
    );
    setProductos(productosComponent);
  }, [homes]);

  // 4) Mostrar popup tras 1s si está activo
  useEffect(() => {
    if (!popupActive) return;
    const timer = setTimeout(() => setShowPopup(true), 1000);
    return () => clearTimeout(timer);
  }, [popupActive]);

  const handleClosePopup = () => setShowPopup(false);

  // 5) Loader mientras loading=true
  if (loading) {
    return <Loader />;
  }

  return (
    <>
      {showPopup && popupActive && (
        <div className="modal-pop-up-home modal-overlay" onClick={handleClosePopup}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            {isMobile ? (
              popupMobile && (
                <a href={popUpLink} className="pop-up-link">
                  <div
                    className="popup-mobile"
                    style={{
                      backgroundImage: `url(${process.env.REACT_APP_STRAPI_API_BASE}${popupMobile})`
                    }}
                  />
                </a>
              )
            ) : (
              popupDesktop && (
                <a href={popUpLink} className="pop-up-link">
                  <div
                    className="popup-desktop"
                    style={{
                      backgroundImage: `url(${process.env.REACT_APP_STRAPI_API_BASE}${popupDesktop})`
                    }}
                  />
                </a>
              )
            )}
            <button onClick={handleClosePopup} className="close-button">
              X
            </button>
          </div>
        </div>
      )}

      <SliderHome
        desktopVideoId={banner?.idVideoYTEscritorio}
        mobileVideoId={banner?.idVideoYTMobile}
      />

      <Características />
      <Productos data={productos} urlMainData="/productos-top" showBanner={false} />
      <Clientes />
      {testimonials.length > 0 && <Testimonial data={testimonials} />}
    </>
  );
};

export default Home;
